export default __webpack_public_path__ + "media/arror-slide.cf04445e.svg";